import { Injectable } from '@angular/core';
import { ILoadingState } from '../modules/core/enumerables/loadingState';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService, LanguageCollectionService } from 'projects/common/src/app/services/parameters';
import {
  TargetAppService,
  AppCollectionService,
  ShiftService,
  ShiftCollectionService,
  DayService,
  ScreenMediaService,
  UserDataService,
} from '../modules/core/services/parameter';
import { TokenService } from './authentication/parameters';
import { PermissionService } from '../modules/core/services/parameter/permission/permission.service';
import { MachineContextService } from '../modules/core/services/parameter/machine-context/machine-context.service';
import { MachineCollectionService } from '../modules/core/services/parameter/machine-collection/machine-collection.service';

@Injectable({
  providedIn: 'root',
})
export class StartService {
  public state: ILoadingState;

  constructor(
    private parameterService: ParameterHandlerService,
    private token: TokenService,
    private shift: ShiftService,
    private shiftCollection: ShiftCollectionService,
    private day: DayService,
    private lang: LanguageService,
    private langCollection: LanguageCollectionService,
    private screenMedia: ScreenMediaService,
    private targetApplication: TargetAppService,
    private appCollection: AppCollectionService,
    private userData: UserDataService,
    private permission: PermissionService,
    private machineContext: MachineContextService,
    private machineCollection: MachineCollectionService,
  ) {}

  /**
   * Inicializa funciones
   */
  public init(): void {
    this.subscribeParameters();
    this.userData.startWhen(this.token.getObservable());
    this.permission.startWhen(this.token.getObservable());
    this.appCollection.startWhen(this.permission.getObservable());
    this.targetApplication.startWhen(this.appCollection.getObservable());
    this.shift.startWhen(this.shiftCollection.getObservable());
    this.machineCollection.startWhen(this.targetApplication.getObservable());
  }

  /**
   * Subscripción a parámetros principales de la aplicación
   */
  public subscribeParameters(): void {
    this.parameterService.subscribe(this.shiftCollection, true);
    this.parameterService.subscribe(this.machineCollection);
    this.parameterService.subscribe(this.shift, true);
    this.parameterService.subscribe(this.day, true);
    this.parameterService.subscribe(this.lang);
    this.parameterService.subscribe(this.langCollection);
    this.parameterService.subscribe(this.screenMedia);
    this.parameterService.subscribe(this.targetApplication);
    this.parameterService.subscribe(this.token, true, true);
    this.parameterService.subscribe(this.machineContext, true);
    this.parameterService.subscribe(this.appCollection);
    this.parameterService.subscribe(this.userData);
    this.parameterService.subscribe(this.permission);
    this.parameterService.restore();
  }
}
